import * as React from "react";

class Loader extends React.Component {

	render() {
		return (
			<div id="loader-wrap">
				<div id="loader">
					<div className="loaderBall">
						<div className="ball ball1">&nbsp;</div>
					</div>
					<div className="loaderBall">
						<div className="ball ball2">&nbsp;</div>
					</div>
					<div className="loaderBall">
						<div className="ball ball3">&nbsp;</div>
					</div>
					<div className="loaderBall">
						<div className="ball ball4">&nbsp;</div>
					</div>
				</div>
			</div>
		)
	}
}

export default Loader;


// WEBPACK FOOTER //
// ./src/components/Loader.jsx